var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6666 25.6665H2.33325",
    stroke: "#939CB4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.5 25.6665V16.9165C24.5 15.95 23.7165 15.1665 22.75 15.1665H19.25C18.2835 15.1665 17.5 15.95 17.5 16.9165V25.6665",
    stroke: "#939CB4",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 25.6668V5.8335C17.5 4.18358 17.5 3.35862 16.9874 2.84606C16.4749 2.3335 15.6499 2.3335 14 2.3335C12.3501 2.3335 11.5251 2.3335 11.0126 2.84606C10.5 3.35862 10.5 4.18358 10.5 5.8335V25.6668",
    stroke: "#939CB4",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.5 25.6668V11.0835C10.5 10.117 9.7165 9.3335 8.75 9.3335H5.25C4.2835 9.3335 3.5 10.117 3.5 11.0835V25.6668",
    stroke: "#939CB4",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.7dbab0bb32c6d53f59c5b5c9b0483612.svg";
export { ForwardRef as ReactComponent };